import React, { useState } from "react";
import {
  Box,
  Card,
  CardContent,
  Typography,
  IconButton,
  Grid,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import ConfirmationDialog from "../ConfirmationDialog";
import { CircularProgress } from "@mui/material";
import { logger } from "../../utils/logger";

const DropdownTabContent = ({
  options,
  onEdit,
  onDelete,
  loading,
  username,
  role,
}) => {
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState(null);

  const handleDeleteClick = (index) => {
    setSelectedIndex(index);
    setConfirmOpen(true);
    const option = options[index];
    logger.info("Delete confirmation opened", {
      optionName: option?.value,
      username,
      role,
    });
  };

  const handleConfirmDelete = () => {
    if (selectedIndex !== null) {
      const option = options[selectedIndex];

      logger.info("Option deleted", {
        optionName: option?.value,
        username,
        role,
      });

      onDelete(selectedIndex);
      setConfirmOpen(false);
      setSelectedIndex(null);
    }
  };

  const handleCancelDelete = () => {
    if (selectedIndex !== null) {
      const option = options[selectedIndex];
      logger.info("Delete cancelled", {
        optionName: option?.value,
        username,
        role,
      });
    }
    setConfirmOpen(false);
    setSelectedIndex(null);
  };

  if (loading) {
    return (
      <Box sx={{ display: "flex", justifyContent: "center", mt: 3 }}>
        <CircularProgress />
      </Box>
    );
  }
  return (
    <Box sx={{ mt: 2, width: "100%" }}>
      <Grid container spacing={2}>
        {options.map((opt, index) => (
          <Grid item xs={12} sm={4} md={4} key={opt._id}>
            <Card
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                px: 2,
                py: 1,
                minWidth: 140,
                height: 45,
                borderRadius: 1,
                boxShadow: 1,
              }}
            >
              <Box>
                {!["tamilmonths", "nachathiram", "thithi"].includes(
                  opt.type
                ) && (
                  <IconButton
                    onClick={() => onEdit(opt)}
                    title="Edit Option"
                    aria-label="Edit Option"
                    data-log="Edit Icon Button"
                  >
                    <EditIcon color="primary" />
                  </IconButton>
                )}

                <IconButton
                  onClick={() => handleDeleteClick(index)}
                  title="Delete Option"
                  aria-label="Delete Option"
                  data-log="Delete Icon Button"
                >
                  <DeleteIcon color="error" />
                </IconButton>
              </Box>
              <CardContent sx={{ flex: 1 }}>
                <Typography
                  noWrap
                  sx={{ maxWidth: "100%", fontSize: "0.85rem" }}
                  title={opt.value}
                >
                  {opt.tamilValue ? opt.tamilValue : opt.value}
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
      {/* Confirmation Dialog */}
      <ConfirmationDialog
        open={confirmOpen}
        title="Delete Option"
        message="Are you sure you want to delete this option?"
        onConfirm={handleConfirmDelete}
        onCancel={handleCancelDelete}
      />
    </Box>
  );
};

export default DropdownTabContent;
